var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#facdd5}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.37 23.97c0 3.42-.01 6.84.01 10.26.01 1.13-.49 1.92-1.44 2.47-2.02 1.16-4.03 2.33-6.05 3.49-3.09 1.79-6.17 3.58-9.25 5.37-.86.5-1.71 1-2.57 1.48-.8.43-1.65.42-2.41-.01-1.96-1.1-3.89-2.25-5.83-3.38-1.41-.82-2.82-1.62-4.23-2.44-1.96-1.13-3.91-2.27-5.86-3.41-.7-.4-1.39-.82-2.08-1.22-.82-.47-1.21-1.14-1.21-2.1.01-6.91.03-13.81-.01-20.72-.01-1.3.52-2.09 1.61-2.7 2.22-1.25 4.41-2.56 6.61-3.84 2.22-1.29 4.44-2.56 6.66-3.85 1.13-.65 2.25-1.34 3.4-1.96.65-.35 1.23-.81 2.06-.84.99-.04 1.69.5 2.45.93 2.01 1.14 4.01 2.32 6.01 3.48 2.17 1.26 4.35 2.52 6.52 3.78 1.48.86 2.94 1.73 4.42 2.58.88.51 1.22 1.3 1.22 2.26-.03 3.46-.03 6.92-.03 10.37zM13.94 19.1c.07.75.15 1.5.21 2.25.14 1.65.63 3.21 1.23 4.74.93 2.34 2.37 4.33 4.23 6.03 1.07.97 2.22 1.8 3.58 2.29.45.16 1.06.17 1.5-.01 2.86-1.15 4.89-3.29 6.54-5.8 1.89-2.89 2.63-6.15 2.71-9.58.03-1.31-.35-1.86-1.55-2.35-2.5-1.03-5-2.05-7.48-3.11-.69-.3-1.31-.29-1.98-.01-2.44 1.03-4.88 2.05-7.33 3.06-1.37.58-1.65.99-1.66 2.49z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.94 19.1c.02-1.5.29-1.91 1.67-2.48 2.45-1.01 4.89-2.03 7.33-3.06.67-.28 1.29-.29 1.98.01 2.48 1.06 4.98 2.08 7.48 3.11 1.2.5 1.58 1.04 1.55 2.35-.08 3.42-.82 6.69-2.71 9.58-1.64 2.51-3.68 4.65-6.54 5.8-.44.17-1.05.17-1.5.01-1.36-.48-2.51-1.31-3.58-2.29-1.86-1.7-3.3-3.69-4.23-6.03-.61-1.52-1.09-3.09-1.23-4.74-.07-.76-.15-1.51-.22-2.26zM24 31.73c1.73-.84 3.04-2.06 4.15-3.52 1.95-2.56 2.95-5.45 3-8.68 0-.32-.09-.46-.39-.59-1.58-.65-3.14-1.34-4.72-2-.66-.28-1.32-.53-2.04-.82v15.61z",
    style: {
      fill: "#e93a59"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31.73v-15.6c.72.29 1.38.54 2.04.82 1.57.66 3.14 1.35 4.72 2 .3.12.39.27.39.59-.05 3.22-1.05 6.11-3 8.68-1.11 1.45-2.42 2.67-4.15 3.51z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityMonitor);
export default __webpack_public_path__ + "static/media/security-monitor.da3ccafc5fbd842cd9c33efdf493daef.svg";
export { ForwardRef as ReactComponent };